export default __webpack_public_path__ + "static/media/DashboardInactiveLight.a2b84eb7.svg";